



























































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { MswWidgetCard } from '@/shared/custom-component/msw-widget-card';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { currentUserKey } from '@/shared/msw-constants';
const cssPrefix = 'msw-contemporary-widget';

@Component({
  components: {
    MswWidgetCard,
    SwIcon,
  },
})
export default class MswContemporaryWidget extends SwExtendedVue {
  cssPrefix =  cssPrefix;

  redirectToContemporaryMode() {
    const contemporaryModeURL = this.$store.getters.getContemporaryURL;
    const contempararyModeQaURL = this.$store.getters.getContemporaryQaURL;
    const currentUser = localStorage.getItem(currentUserKey);
    const token = currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
    let redirectURL = '';
    const localDomain = window.location.href;
    if (localDomain.indexOf('msw.eng.sonicwall.com') > -1) {
      redirectURL = `${contemporaryModeURL}/muir/login?tok=${token}&mode=workflow`;
    } else if (localDomain.indexOf('10.5.50.121') > -1) {
      redirectURL = `${contempararyModeQaURL}/muir/login?tok=${token}&mode=workflow`;
    } else if (localDomain.indexOf('localhost') > -1) {
      redirectURL = `${contemporaryModeURL}/muir/login?tok=${token}&mode=workflow`;
    } else if (localDomain.indexOf('10.202.8.44') > -1) {
      redirectURL = `${contemporaryModeURL}/muir/login?tok=${token}&mode=workflow`;
    } else {
      redirectURL = `${window.location.origin}/muir/ui/home`;
    }
    // location.replace is useful for any 301 redirect scenario, including when you need to redirect from HTTP to HTTPS.
    location.replace(redirectURL);
  }
}
